const STATE_NAME = 'app.account';
const ROUTE = '/account';
const REDIRECT_TO = `${ROUTE}/profile`;

export default function AccountConfig($stateProvider, $urlRouterProvider) {
  'ngInject';
  // Default to /account/profile
  $urlRouterProvider.when(ROUTE, REDIRECT_TO);

  // Define the abstract state
  $stateProvider.state(STATE_NAME, {
    abstract: true,
    url: ROUTE,
    views: {
      '@': {
        template: '<uapp-account></uapp-account>',
      },
    },
    // `when` here is used for breadcrumb directive
    // TODO: Remove once we replace with `u-breadcrumb`
    when: 'app.account.profile',
    title: 'My Account',
    data: {
      permissions: 'signedIn && hasAccessToAccountFeatures',
    },
  });
}
